import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Card
} from 'react-bootstrap';
import PageTitle from '../../common/PageTitle';
import TypeBadge from '../../common/TypeBadge';
import FormattedPrice from '../../common/FormattedPrice';
import { useCart } from '../../../context/CartContext';

const Cart = () => {

  const { cart, updateCart } = useCart();

  const handleRemove = (item) => {
    updateCart(item);
  };

  const handleRemoveAll = () => {
    updateCart(null);
  }

  const handleExport = () => {
    if (cart.length === 0) {
      alert('A lista está vazia. Adicione itens para exportar.');
      return;
    }
  }

  return (
    <>
      <Container>
        <Row>
          <Col>
            <PageTitle text='Exportar para Excel' />
          </Col>
        </Row>
      </Container>
      <Container className="">
        {cart.length > 0 ? (
          <>
            <div className='fs-6'>Total de {cart.length} itens na lista.</div>
            <Table hover size="sm" className="" id="searchTable">
              <thead>
                <tr>
                  <th>Praça<br />Base<br />Versão</th>
                  <th>Tipo</th>
                  <th>Código</th>
                  <th>Grupo de custos<br />Descrição</th>
                  <th>Un.</th>
                  <th>Preços</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {cart && Array.isArray(cart) && cart.map((result, index) => (
                  <tr key={index}>
                    <td valign='middle' className='text-nowrap'>{result.praca} <br /> {result.base} <br /> {result.release}</td>
                    <td valign='middle'><TypeBadge type={result.type} /></td>
                    <td valign='middle'>{result.code}</td>
                    <td valign='middle'><span className='text-secondary'>{result.CostGroup.description}</span><br />{result.description}</td>
                    <td valign='middle'>{result.unity}</td>
                    <td className='text-nowrap'>
                      <FormattedPrice type='clsd' price={result.ElementPrices.length > 0 ? result.ElementPrices[0].clsd : 0} />
                      <br />
                      <FormattedPrice type='clsn' price={result.ElementPrices.length > 0 ? result.ElementPrices[0].clsn : 0} />
                      <br />
                      <FormattedPrice type='sls' price={result.ElementPrices.length > 0 ? result.ElementPrices[0].sls : 0} />
                    </td>
                    <td valign='middle' className='text-nowrap '>
                      <Button variant='link' className='' onClick={() => handleRemove(result)}>
                        <div className='text-danger'>
                          <i className="bi bi-dash-circle"></i>
                        </div>
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        ) : (
          <Row>
            <Col md={12}>
              <Card className="text-center">
                <Card.Body>
                  <Card.Title>Lista Vazia</Card.Title>
                  <Card.Text>
                    Pesquise por itens para adicionar à lista.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}
        <Row>
          <Col md={12} className='mt-1'>
            {cart.length > 0 && (
              <div>
                <Button className='btn btn-sm me-1' variant="primary" onClick={() => handleExport()}>Exportar lista</Button>
                <Button className='btn btn-sm me-1' variant="secondary" onClick={() => handleRemoveAll()}>Limpar lista</Button>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Cart;